import * as React from 'react';
import {Row} from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import {DashboardCard, DashboardRow} from './utils';
import Form from 'react-bootstrap/Form';
import {Action, Copy, Help} from '../../system/buttons';
import twitter from '../../twitter.png';
import {DirectLink} from '../welcome/Welcome';
import {ReferralFeatureDescription} from '../../system/FeatureDescriptionModal';
import PulsoidClient from '../../PulsoidClient';
import {faGrinBeam, faGrinHearts} from '@fortawesome/free-solid-svg-icons';
import {MetaReferralWidget} from '@pulsoid-private/widgets-lib';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../navigation/navigationUtils';

export class Referral extends React.Component {
  state = {};

  componentDidMount() {
    new PulsoidClient().getReferralStatistics().then((referralStatistics) =>
      this.setState({referralStatistics}, () => {
        if (
          window.location.hash.includes('referral') &&
          document.getElementById('referral')
        ) {
          document.getElementById('referral').scrollIntoView();
        }
      })
    );
    new PulsoidClient().getAllWidgets().then((widgets) => {
      for (const widget of widgets) {
        if (widget.metaId === MetaReferralWidget) {
          this.setState({referralWidget: widget});
          return;
        }
      }
      this.setState({showAddReferralWidget: true});
    });
  }

  render() {
    return (
      <DashboardRow header={'Referral Program'} id={'referral'}>
        <h5>
          Invite Friend and You Both Get a Week of BRO Plan{' '}
          <span role={'img'} aria-label={'Star'}>
            🌟
          </span>
          <ReferralFeatureDescription />
        </h5>
        <Row>
          <Col>
            Share the easiest way to stream heart rate with your friends and
            viewers. Feel free to include images from Pulsoid{' '}
            <DirectLink
              text={'Media Pack'}
              href="https://pulsoid.net/s/media-pack"
              target="_blank"
            />
            .
          </Col>
        </Row>

        <Form.Group as={Row}>
          <Col>
            <Form.Control value={this.props.referralUrl} readOnly />
          </Col>
          <Col>
            <Copy text={this.props.referralUrl} />
            &nbsp; &nbsp;
            <DirectLink
              href={`https://twitter.com/intent/tweet?text=Add%20real-time%20heart%20rate%20widgets%20to%20your%20stream%20with%20@pulsoid_app%20using%20my%20link%20and%20get%20an%20extra%20week%20of%20premium:%20${this.props.referralUrl}`}
              text={
                <img alt="Twitter logo" border="0" src={twitter} width="35" />
              }
            />
          </Col>
        </Form.Group>
        {this.state && this.state.referralStatistics && (
          <Row>
            <Col className="p-2">
              {' '}
              <DashboardCard
                type="dark"
                value={
                  this.state.referralStatistics.referralProfileRegistered +
                  this.state.referralStatistics.referralProfileStreamed +
                  this.state.referralStatistics.referralBonusApplied
                }
                description="Invited"
                icon={faGrinBeam}
              />
            </Col>

            <Col className="p-2">
              {' '}
              <DashboardCard
                type="info"
                value={
                  this.state.referralStatistics.referralProfileStreamed +
                  this.state.referralStatistics.referralBonusApplied
                }
                description="Streamed"
                icon={faGrinHearts}
              />
            </Col>
          </Row>
        )}
        {this.state.referralWidget && (
          <>
            <h5>Referral widget</h5>
            <Row>
              <Col>
                <Form.Control
                  className={'p-2'}
                  value={
                    'https://pulsoid.net/widget/view/' +
                    this.state.referralWidget.id
                  }
                  readOnly
                />
              </Col>
              <Col>
                <Copy
                  text={
                    'https://pulsoid.net/widget/view/' +
                    this.state.referralWidget.id
                  }
                />
                &nbsp;
                <Help
                  href={buildRoute({
                    path: DASHBOARD_ROUTES.CONFIGURATION_EDIT_WIDGET,
                    params: {id: this.state.referralWidget.id},
                  })}
                >
                  Configure
                </Help>
              </Col>
            </Row>
          </>
        )}
        {this.state.showAddReferralWidget && (
          <>
            <h5>Referral widget</h5>
            <Row>
              <Col>
                <Action
                  href={buildRoute({
                    path: DASHBOARD_ROUTES.CONFIGURATION_ADD_WIDGET,
                    params: {
                      predefinedWidgetId:
                        '0e1ce83f-32fa-4f61-a4e6-ef0fd7a73dcf',
                    },
                  })}
                >
                  Add to my widgets
                </Action>
              </Col>
            </Row>
          </>
        )}
      </DashboardRow>
    );
  }
}
